// extracted by mini-css-extract-plugin
export default {"directions":"Directions_directions__GQXC-","direction":"Directions_direction__wVZ94","columns":"Directions_columns__zOiUX","column":"Directions_column__7Zloz"};